import { c as _c } from "react/compiler-runtime";
import Box from '@mui/material/Box';
import { RouterLink } from 'src/routes/components';
import { paths, newSearchParams } from 'src/routes/paths';
import { Iconify } from 'src/components/iconify';
import { ButtonFollow } from 'src/components/custom-buttons';

// ----------------------------------------------------------------------

export function AccountTitle(t0) {
  const $ = _c(36);
  let hideButton;
  let other;
  let slotProps;
  let sx;
  let user;
  if ($[0] !== t0) {
    ({
      user,
      slotProps,
      hideButton,
      sx,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = hideButton;
    $[2] = other;
    $[3] = slotProps;
    $[4] = sx;
    $[5] = user;
  } else {
    hideButton = $[1];
    other = $[2];
    slotProps = $[3];
    sx = $[4];
    user = $[5];
  }
  let t1;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      gap: 1,
      width: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    };
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== sx) {
    t2 = Array.isArray(sx) ? sx : [sx];
    $[7] = sx;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t2) {
    t3 = [t1, ...t2];
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      gap: 0.5,
      display: "grid",
      alignItems: "center",
      gridTemplateColumns: "1fr auto"
    };
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const t5 = `${paths.user.profile(user?.id)}${newSearchParams({
    country: user?.country
  })}`;
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      color: "inherit",
      display: "inline-block",
      textDecoration: "none"
    };
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== slotProps?.title?.sx) {
    t7 = Array.isArray(slotProps?.title?.sx) ? slotProps?.title?.sx ?? [] : [slotProps?.title?.sx];
    $[13] = slotProps?.title?.sx;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = [t6, ...t7];
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const t9 = user?.companyName;
  let t10;
  if ($[17] !== t5 || $[18] !== t8 || $[19] !== t9) {
    t10 = <Box className="noWrap" component={RouterLink} href={t5} sx={t8}>{t9}</Box>;
    $[17] = t5;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== slotProps?.iconify?.sx || $[22] !== user?.verifiedAccount) {
    t11 = user?.verifiedAccount && <Iconify width={16} icon="solar:verified-check-bold" sx={[{
      color: "info.main"
    }, ...(Array.isArray(slotProps?.iconify?.sx) ? slotProps?.iconify?.sx ?? [] : [slotProps?.iconify?.sx])]} />;
    $[21] = slotProps?.iconify?.sx;
    $[22] = user?.verifiedAccount;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t10 || $[25] !== t11) {
    t12 = <Box sx={t4}>{t10}{t11}</Box>;
    $[24] = t10;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== hideButton || $[28] !== slotProps?.button?.sx || $[29] !== user?.id) {
    t13 = user?.id && !hideButton && <ButtonFollow userId={user?.id} sx={[...(Array.isArray(slotProps?.button?.sx) ? slotProps?.button?.sx ?? [] : [slotProps?.button?.sx])]} />;
    $[27] = hideButton;
    $[28] = slotProps?.button?.sx;
    $[29] = user?.id;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== other || $[32] !== t12 || $[33] !== t13 || $[34] !== t3) {
    t14 = <Box sx={t3} {...other}>{t12}{t13}</Box>;
    $[31] = other;
    $[32] = t12;
    $[33] = t13;
    $[34] = t3;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  return t14;
}